module.exports = __webpack_public_path__ + "static/media/registryconversion_zolaintegration.955c4764.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/registryconversion_zolaintegration.jpg
// module id = 1795
// module chunks = 50